import React from "react";
import { useState } from "react";
import EmptyModal from "./emptyModal";

export let setModalData: (args: {
	title: string | JSX.Element;
	message: string | JSX.Element;
}) => void;

export const popup = () => {
	($("#messageModal") as any).modal();
	return;
};

export default function MessageModal() {
	const [data, setData] = useState({ title: "", message: "" });
	setModalData = setData as any;

	const buttons = (
		<React.Fragment>
			<button
				type="button"
				className="btn btn-primary"
				data-dismiss="modal"
				style={{ margin: "auto" }}
			>
				OK
			</button>
		</React.Fragment>
	);

	return (
		<EmptyModal
			id="messageModal"
			title={data.title}
			message={data.message}
			buttons={buttons}
		/>
	);
}
